const env: string | undefined = import.meta.env.NODE_ENV

export const isMock: boolean = import.meta.env.VITE_MOCK_ENV === 'true'
export const isDev: boolean = env === 'test' || isMock
export const windowParams = isMock ? window.location.hash : window.location.pathname

export default env
